import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkles, ArrowLeft } from "lucide-react";

export default function LegalPage() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  useEffect(() => {
    api.get(`/legal/${slug}`).then(({ data }) => setDoc(data));
  }, [slug]);
  if (!doc) return <div className="cosmic-bg min-h-screen flex items-center justify-center text-white/60">Yükleniyor...</div>;

  return (
    <div className="cosmic-bg min-h-screen">
      <div className="stars" />
      <header className="sticky top-0 z-50 glass-strong">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-2">
          <Link to="/" className="flex items-center gap-2"><Sparkles className="w-5 h-5 gold-text" /><span className="font-serif-myst text-xl">FalZilla</span></Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
        <Link to="/" className="text-white/60 text-sm hover:gold-text flex items-center gap-1">
          <ArrowLeft className="w-4 h-4" /> Ana sayfa
        </Link>
        <article className="glass-strong rounded-3xl p-6 md:p-10 mt-6">
          <h1 className="font-serif-myst text-4xl md:text-5xl mb-6 gold-text">{doc.title}</h1>
          <div className="prose prose-invert max-w-none whitespace-pre-wrap text-white/85 leading-relaxed">
            {doc.content}
          </div>
        </article>
      </main>
    </div>
  );
}
